import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../../../services/meta-service.service';
@Component({
  selector: 'app-high-speed-doors',
  templateUrl: './high-speed-doors.component.html',
  styleUrls: ['./high-speed-doors.component.scss']
})
export class HighSpeedDoorsComponent implements OnInit {
    page: any;
    sstwhite  = true;
    sstblack = false;

    sttblack = true;
    sttwhite = false;

    srtblack = true;
    srtwhite = false;

    strblack = true;
    strwhite = false;

    mtlblack = true;
    mtlwhite = false;


  constructor(private route: ActivatedRoute, private metaService: MetaService) { }

  ngOnInit(): void {
    this.metaService.setCanonicalURL();
    this.route.queryParams.subscribe(params => {
        this.page = params.page;
    });  }


    turnWhite(imgname) {
        if (imgname === 'sst') {
            this.sstwhite  = true;
            this.sstblack = false;

            this.sttblack = true;
            this.sttwhite = false;

            this.srtblack = true;
            this.srtwhite = false;

            this.strblack = true;
            this.strwhite = false;

            this.mtlblack = true;
            this.mtlwhite = false;
        } else if (imgname === 'stt') {
            this.sstwhite  = false;
            this.sstblack = true;

            this.sttblack = false;
            this.sttwhite = true;

            this.srtblack = true;
            this.srtwhite = false;

            this.strblack = true;
            this.strwhite = false;

            this.mtlblack = true;
            this.mtlwhite = false;
        } else if (imgname === 'srt') {
            this.sstwhite  = false;
            this.sstblack = true;

            this.sttblack = true;
            this.sttwhite = false;

            this.srtblack = false;
            this.srtwhite = true;

            this.strblack = true;
            this.strwhite = false;

            this.mtlblack = true;
            this.mtlwhite = false;
        } else if (imgname === 'str') {
            this.sstwhite  = false;
            this.sstblack = true;

            this.sttblack = true;
            this.sttwhite = false;

            this.srtblack = true;
            this.srtwhite = false;

            this.strblack = false;
            this.strwhite = true;

            this.mtlblack = true;
            this.mtlwhite = false;
        } else if (imgname === 'mtl') {
            this.sstwhite  = false;
            this.sstblack = true;

            this.sttblack = true;
            this.sttwhite = false;

            this.srtblack = true;
            this.srtwhite = false;

            this.strblack = true;
            this.strwhite = false;

            this.mtlblack = false;
            this.mtlwhite = true;
        } else {
            this.sstwhite  = true;
            this.sstblack = false;

            this.sttblack = true;
            this.sttwhite = false;

            this.srtblack = true;
            this.srtwhite = false;

            this.strblack = true;
            this.strwhite = false;

            this.mtlblack = true;
            this.mtlwhite = false;
        }

    }

}
